import { render, staticRenderFns } from "./AuthoringToolMiniView.vue?vue&type=template&id=356f49c4&"
import script from "./AuthoringToolMiniView.vue?vue&type=script&lang=js&"
export * from "./AuthoringToolMiniView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports